<template>
  <div class="staffing">
    <el-table :data="tableData" style="width: 100%" class="w100  table">
      <el-table-column label="序号" type="index" width="60">
        <!-- <el-table-column prop="name" label="姓名"> </el-table-column> -->
      </el-table-column>
      <el-table-column label="类别">
        <el-table-column prop="name" label="退休人员"> </el-table-column>
      </el-table-column>
      <el-table-column label="应发" align="center">
        <el-table-column prop="reformPay" label="改革后退休人员独生女补助" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="lifePay" label="生活补助" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="propertyPay" label="物业补贴" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="springPay" label="春节慰问金" show-overflow-tooltip>
        </el-table-column>
        
        <el-table-column prop="otherPay" label="其他" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mustTotal" label="应发合计" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
      <el-table-column>

        <el-table-column prop="actualPay" label="实发合计" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="payTime" label="发放日期" show-overflow-tooltip>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    tableData:{
      default:[],
      require:true
    }
  },
  data() {
    return {
    };
  },
  methods: {
   
  },
};
</script>

<style lang="less" scoped>
 /deep/.el-table {
    width: 100%;
    height: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>